import moment from 'moment';
import React from 'react'
import { Col, Row } from 'reactstrap';
import { ICaseTaskHistoryModel } from '../../../models/Cases/CaseDetailsModel';

interface ICaseTaskHistoryProps {
  taskHistory: ICaseTaskHistoryModel[] | [];
}

const CaseTaskHistory = (props: ICaseTaskHistoryProps) => {
  return (
    <div>
      <div className="historyModel">
        { props?.taskHistory?.length > 0 ? (
          props?.taskHistory?.map((element: ICaseTaskHistoryModel) => (
            <Row className="infoPack" key={element?.taskHistoryId}>
              <Col md="2">{element?.createdByName || "-"}</Col>
              <Col md="1" className="">
                {moment(moment.utc(element?.createdDate)?.toDate())?.format('M/DD/YY') || "-"}
              </Col>
              <Col md="2" className="timeDate">
                {moment(moment.utc(element?.createdDate)?.toDate())?.format('hh:mm A') || "-"} 
              </Col>
              <Col>{element?.taskInfo || "-"}</Col>
            </Row>
          ))
        ) : (
          <Row className="infoPack">
            <Col className='not-found'>No records found</Col>
          </Row>
        )}
      </div>
    </div>
  )
}

export default CaseTaskHistory